import { render, staticRenderFns } from "./VaColorPicker.vue?vue&type=template&id=cf701718&scoped=true&"
import script from "./VaColorPicker.vue?vue&type=script&lang=js&"
export * from "./VaColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./VaColorPicker.vue?vue&type=style&index=0&id=cf701718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf701718",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VColorPicker,VTextField})
